import React, { useState, useEffect } from "react";

export default function AiIcon({ onClick }) {
  const [showMessage, setShowMessage] = useState(false);
  const [hovered, setHovered] = useState(false);

  // Auto show message after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Hide message when not hovered
  useEffect(() => {
    if (!hovered) {
      const hideTimer = setTimeout(() => setShowMessage(false), 3000); // hide after 3 sec
      return () => clearTimeout(hideTimer);
    }
  }, [hovered]);

  return (
    <div
      style={styles.container}
      onMouseEnter={() => {
        setHovered(true);
        setShowMessage(true);
      }}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      {/* Chef Icon */}
      <img
        src="https://img.freepik.com/premium-vector/beautiful-woman-chef-mascot-logo-vector-illustration-female-character-with-hat-chef-uniform_135170-5460.jpg?w=2000"
        alt="Recipe Assistant"
        style={styles.icon}
      />

      {/* Hover/Auto Message */}
      {showMessage && (
        <div style={styles.message}>
          Recipe Assistant 
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 1000,
    cursor: "pointer",
  },
  icon: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
  },
  message: {
    position: "absolute",
    bottom: 70,
    right: 0,
    background: "#fc0404",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    whiteSpace: "nowrap",
    fontSize: "14px",
    fontWeight: "500",
    transition: "opacity 0.3s",
  },
};